// Converted to TypeScript
/* Add appropriate types here */
/***
 *
 *   SIGN IN
 *   Sign in form for all account types (including master).
 *
 **********/

import { useContext, useEffect, useState } from "react";
import {
  AuthContext,
  ViewContext,
  Link,
  useLocation,
  useNavigate,
  Loader,
  Logo
} from "@/components/lib";
import axios from "axios";
import { useForm } from "react-hook-form";
import Styles from "@/css/mainStyles";

export function Signin() {
  // context
  const authContext = useContext<any>(AuthContext);
  const viewContext = useContext<any>(ViewContext);
  // --------------------
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({});

  useEffect(() => {
    // was an error message passed from the server router?
    const qs = location.search;

    if (qs.includes("error")) {
      const msg = decodeURIComponent(qs.substring(qs.indexOf("?error=") + 7));
      viewContext.notification.show(msg, "error");
    }
  }, [location.search, viewContext.notification]);

  const onSubmit = async (data: any) => {
    try {
      setLoading(true);
      const res = await axios({
        method: "post",
        url: "/api/auth",
        data
      });

      res.data["2fa_required"]
        ? navigate(`/signin/otp?token=${res.data.token}`)
        : navigate(authContext.signin(res));
    } catch (error) {
      console.error(error);
      let message = error.response?.data?.message
        ? error.response.data.message
        : error.message;
      if (message === "Validation Error in body" && error.response.data?.errors?.length > 0) {
        message = error.response.data.errors[0].message;
      }
      viewContext.notification.show(message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col justify-center h-screen p-8 md:px-32 text-left lg:w-1/2">
      <Logo className="w-80 lg:w-96 mx-auto my-5 lg:mb-12" />
      <h1 className="font-bold text-2xl lg:text-4xl text-center">Login</h1>
      <form
        className="flex flex-col items-center gap-6 mt-7"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex flex-col flex-1 w-full">
          <label className={Styles.label}>Email</label>
          <input
            placeholder="Enter Email"
            type="email"
            className={Styles.input}
            {...register("email", { required: true })}
            style={errors.email && { border: "1px solid red" }}
          />
        </div>
        <div className="flex flex-col flex-1 w-full">
          <label className={Styles.label}>Password</label>
          <input
            placeholder="Enter Password"
            type="password"
            className={Styles.input}
            {...register("password", { required: true })}
            style={errors.password && { border: "1px solid red" }}
          />
          <Link
            url="/forgot-password"
            text="Forgot your password?"
            color="dark"
            noUnderline
            className="mt-2 ml-2 lg:text-xl"
          />
        </div>
        <button type="submit" className={Styles.submitButton}>
          Continue
          {loading && <Loader />}
        </button>
      </form>

      <div className="mt-4 text-center flex justify-center gap-2">
        <p>Don't have an account?</p>
        <Link url="/signup" text="Sign Up" color="dark" noUnderline />
      </div>
    </div>
  );
}
